// apps/crm/src/lib/plan-action.ts
//
// P0-6 (Onda 0) — decide a ação de troca de plano do clube.
//
// Bug corrigido: PlanUpgradeDialog gravava `clubs.plan_tier` DIRETO do browser
// (`supabase.from('clubs').update({ plan_tier })`), virando Enterprise sem pagar
// (e, no sentido inverso, derrubando o tier sem cancelar a assinatura Stripe).
//
// Correção: toda troca passa pelas edge functions autenticadas —
//   upgrade   → club-upgrade-checkout (Stripe Checkout, ou ativação por cupom)
//   downgrade → club-downgrade (cancela a assinatura Stripe)
// Este módulo é PURE (sem React/rede): decide a ação; o componente faz o I/O.

export type PlanAction =
  | { kind: "noop" }
  | {
      kind: "upgrade";
      fn: "club-upgrade-checkout";
      body: { club_id: string; plan_tier: string; return_url: string };
    }
  | {
      kind: "downgrade";
      fn: "club-downgrade";
      body: { club_id: string; target_tier: string };
    };

// Hierarquia canônica dos tiers — espelha `usePlanFeatures` e
// `supabase/functions/_shared/club-subscription.ts`. 'pro' saiu do catálogo
// (20260703150000_remove_pro_tier.sql) e 'professor' é o tier interno do modo
// "PPS para Professores", no mesmo nível do enterprise.
//
// Sem 'professor' no mapa, um clube professor caía em `?? 0` e "ir para free"
// virava noop no front (e 400 "Target tier must be lower" no back).
const TIER_ORDER: Record<string, number> = { free: 0, enterprise: 2, professor: 2 };

export function resolvePlanAction(params: {
  clubId: string;
  currentTier: string;
  targetTier: string;
  returnUrl: string;
}): PlanAction {
  const { clubId, currentTier, targetTier, returnUrl } = params;

  if (!targetTier || targetTier === currentTier) return { kind: "noop" };

  const cur = TIER_ORDER[currentTier] ?? 0;
  const tgt = TIER_ORDER[targetTier] ?? 0;

  if (tgt > cur) {
    return {
      kind: "upgrade",
      fn: "club-upgrade-checkout",
      body: { club_id: clubId, plan_tier: targetTier, return_url: returnUrl },
    };
  }

  // Mesmo nível com nome diferente (professor ↔ enterprise): não é upgrade nem
  // downgrade. Sem isto o front chamaria club-downgrade e levaria um 400
  // "Target tier must be lower than current tier".
  if (tgt === cur) return { kind: "noop" };

  return {
    kind: "downgrade",
    fn: "club-downgrade",
    body: { club_id: clubId, target_tier: targetTier },
  };
}
